<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="question-mark-circle-outline"></nb-icon>
        <div class="ml-2">{{ title }}</div>
      </div>
      <button nbButton class="ml-3" (click)="clickedNo()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div i18n>Insight {{ insight_name }} ({{ message }})</div>
    <br />
    <div class="row">
      <div class="col-4 mr-auto" i18n>Provide a reason for terminating the run:</div>
      <div class="col-6 mr-auto">
        <input nbInput style="width: 100%" [(ngModel)]="reasonText" [ngModelOptions]="{ standalone: true }" />
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="clickedNo()">
        {{ noButton }}
      </button>
      <button nbButton class="ml-3" [disabled]="!reasonText" status="danger" (click)="clickedYes()">
        {{ yesButton }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
